<template lang="pug">
    div
        div.title(style="display: flex; justify-content: space-between")
            p {{ $t('accountInfo.paymentText') }}
            p(v-if="showTrialInfo" style="font-size: 18px") {{ $t('accountInfo.trialPeriodText') }} {{leftDays}} {{ $t('accountInfo.trialPeriodUnitText') }} ({{expiryDate}})
            p(v-if="showTrialOverageInfo" style="font-size: 18px") {{ $t('accountInfo.trialOverageText') }} {{expiryDate}}
        List.content(item-layout="vertical" v-if="isPaymentAlive")
            template(v-for="listItem in listItems")
                component(ref="listItem" :is="listItem" v-if="is_data_fetched" :userInfoData="userInfoData" :invoiceData="invoiceData" :total_discount_amounts="total_discount_amounts"
                @reloadUserInfoData="getUserInfoData()" @reloadInvoiceData="setInvoiceData($event)" @reloadPaymentView="reloadPaymentView()" @reloadDiscountData="setDiscountData($event)")
        Spin(size="large" fix v-if="spinShow")
</template>
<script>
import CreditCardListItem from "../../../components/Payment/creditCard/listItem";

import ContactListItem from "../../../components/Payment/contact/listItem";

import CouponListItem from "../../../components/Payment/coupon/listItem";

import PlanListItem from "../../../components/Payment/plan/listItem";

import HistoryListItem from "../../../components/Payment/history/listItem";

import { getEsData } from "@/api/esdata";

import moment from "moment";

export default {
    components: {
        CreditCardListItem,
        ContactListItem,
        CouponListItem,
        PlanListItem,
        HistoryListItem
    },
    data() {
        return {
            is_data_fetched: false,
            actionType: "add",
            modalIsOpened: false,
            userInfoData: {},
            listItems: [CreditCardListItem, ContactListItem, PlanListItem, CouponListItem, HistoryListItem],
            createdDate: new Date(),
            userBillingInfoQuery: {
                isFuzzySearch: false,
                esIndex: "rcm-edgegroup",
                from: 0,
                sort: [{ modifiedDate: { order: "desc" } }],
                filters: [
                    {
                        key: "groupName",
                        type: "string",
                        value: this.$store.state.queryGroupName
                    }
                ],
                _source: ["billing", "createdDate"]
            },
            spinShow: false,
            invoiceData: [],
            isPaymentAlive: true,
            total_discount_amounts: {}
        };
    },
    methods: {
        async getUserInfoData() {
            this.spinShow = true;
            const result = await getEsData(this.userBillingInfoQuery);
            if (result.data.mapData[0].billing) {
                this.userInfoData = result.data.mapData[0].billing;
                this.$store.commit("SET_USER_PAYMENT_STATUS", result.data.mapData[0].billing.paymentStatus);
                console.log();
                if (result.data.mapData[0].billing.subscription && !result.data.mapData[0].billing.paymentStatus) {
                    // 有訂閱,付款失敗
                    this.$store.commit("SET_USER_HAS_CARD", false);
                } else if (result.data.mapData[0].billing.cardId) {
                    this.$store.commit("SET_USER_HAS_CARD", false);
                } else {
                    this.$store.commit("SET_USER_HAS_CARD", true);
                }
            }
            // else {
            //     this.$store.commit("SET_USER_PAYMENT_INFO", this.userInfoData);
            // }
            this.$store.commit("SET_USER_PAYMENT_INFO", this.userInfoData);
            this.createdDate = result.data.mapData[0].createdDate;
            this.$store.commit("SET_USER_CREATE_DATE", this.createdDate);

            this.is_data_fetched = true;
            this.spinShow = false;
        },
        setInvoiceData(data) {
            this.invoiceData = data;
        },
        setDiscountData(data) {
            this.total_discount_amounts = data;
        },
        reloadPaymentView() {
            this.isPaymentAlive = false;
            this.$nextTick(() => {
                this.isPaymentAlive = true;
            });
        }
    },
    async mounted() {
        // 是否顯示優惠碼
        if (!this.$store.state.platformPlan.multiTenancyConfigs.isAllowCouponShow) {
            delete this.listItems[3];
        }
        if (this.$store.state.queryGroupName == "all") {
            this.$router.push({ path: "/account-info/user" });
        } else {
            await this.getUserInfoData();
        }
        if (this.$store.state.failPaymentGroup != "") {
            let paymentSeat = 2;
            if (!this.$store.state.userPaymentInfo.cardId) {
                paymentSeat = 0;
            }
            this.$refs.listItem[paymentSeat].isOpened = true;
            this.$store.commit("SET_FAIL_PAYMENT_GROUP", "");
        }
    },
    computed: {
        expiryDate() {
            return moment(this.createdDate)
                .add(30, "days")
                .format("YYYY-MM-DD");
        },
        leftDays() {
            var currentDate = moment().format("YYYY-MM-DD");
            return moment(this.expiryDate).diff(currentDate, "days");
        },
        showTrialInfo() {
            if (!this.userInfoData.subscription) {
                return 0 < this.leftDays && this.leftDays <= 30 && this.userInfoData.cardId;
            }
            return false;
        },
        showTrialOverageInfo() {
            if (!this.userInfoData.subscription) {
                return this.leftDays <= 0;
            }
            return false;
        }
    }
};
</script>

<style lang="less" scoped>
.title {
    font-size: 24px;
}
.cardTitle {
    font-size: 16px;
    margin-left: 5px;
}
.content {
    margin-top: 20px;
}
.ivu-form-item {
    margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/general/AccountInfo/payment.vue